import Bowser from 'bowser';

export function isBrowserInternetExplorer() {
    const browser = Bowser.getParser(window.navigator.userAgent).getBrowser();

    return browser.name === 'Internet Explorer';
}
